import { useCallback, useContext, useState } from "react";
import styled from "styled-components";
import { PrimaryButton } from "../../../components/button";
import { Checkbox } from "../../../components/forms/checkbox";
import { Icon } from "../../../components/icons";
import { columnFlex, Flex } from "../../../components/layout";
import { useAppLoader } from "../../../components/loader/app-loader-hook";
import { GlobalOverlayContext } from "../../../components/overlay/context";
import { Permission } from "../../../components/permission";
import { CertificateDetails } from "../../../store/verification/models/internal";
import { VerificationService } from "../../../store/verification/service";
import { colours } from "../../../styles/colours";
import { KycStatusWidget } from "./common";

const StyledWidget = styled(KycStatusWidget)`
  color: ${colours.white};
  background: ${colours.darkBlueGrey};
`;

const Wrapper = styled.div`
  ${columnFlex}
`;

const CheckboxWrapper = styled(Wrapper)`
  display: inline-flex;
  margin-bottom: 2em;
  flex-grow: 1;
  justify-content: center;
`;

const CheckboxContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  margin: auto;
`;

const Container = styled.div`
  ${columnFlex}
  height: 100%;
`;

export const CertificateDownloader = () => {
  const loader = useAppLoader();
  const { setOverlay } = useContext(GlobalOverlayContext);

  const [checkedOptions, setCheckedOptions] = useState<
    Array<typeof CertificateDetails.T>
  >(CertificateDetails.keys);

  const onClickHandler = useCallback(() => {
    loader(
      VerificationService.downloadCertificate(checkedOptions).toPromise()
    ).then(() =>
      setOverlay({
        children: null,
      })
    );
  }, [checkedOptions, loader, setOverlay]);

  return (
    <Container>
      <p>
        Please select the fields to be displayed on your Sekuritance KYC
        Certificate.
      </p>
      <CheckboxWrapper>
        <CheckboxContainer>
          {CertificateDetails.keys.map((key) => (
            <Checkbox
              label={CertificateDetails.enum[key]}
              checked={checkedOptions.includes(key)}
              onChange={(e) => {
                if (e.target.checked && !checkedOptions.includes(key)) {
                  setCheckedOptions([...checkedOptions, key]);
                } else if (!e.target.checked && checkedOptions.includes(key)) {
                  setCheckedOptions(checkedOptions.filter((o) => o !== key));
                }
              }}
              key={key}
            />
          ))}
        </CheckboxContainer>
      </CheckboxWrapper>
      <Wrapper>
        <PrimaryButton icon="download" onClick={onClickHandler}>
          Download
        </PrimaryButton>
      </Wrapper>
    </Container>
  );
};

export const CertificateTile = () => {
  const { setOverlay } = useContext(GlobalOverlayContext);

  const onClickHandler = useCallback(() => {
    setOverlay({
      title: "Download Certificate",
      children: <CertificateDownloader />,
    });
  }, [setOverlay]);

  return (
    <Permission roles={["ROLE_USER"]}>
      <StyledWidget
        title="Download Certificate:"
        center
        onClick={onClickHandler}
      >
        <Flex center>
          <Icon
            type="certificate"
            colour1={colours.white}
            colour2={colours.darkBlueGrey}
          />
        </Flex>
      </StyledWidget>
    </Permission>
  );
};
